/**
 * Predefined hormonal markers and units for blood test result forms.
 */

export const HORMONAL_MARKERS: { name: string; defaultUnit: string }[] = [
  { name: "FSH", defaultUnit: "mIU/mL" },
  { name: "LH", defaultUnit: "mIU/mL" },
  { name: "Estradiol (E2)", defaultUnit: "pg/mL" },
  { name: "AMH", defaultUnit: "ng/mL" },
  { name: "Progesterone", defaultUnit: "ng/mL" },
  { name: "TSH", defaultUnit: "mIU/L" },
  { name: "Prolactin", defaultUnit: "ng/mL" },
  { name: "Testosterone", defaultUnit: "ng/dL" },
  { name: "DHEA-S", defaultUnit: "μg/dL" },
  { name: "Free T4", defaultUnit: "ng/dL" },
  { name: "Inhibin B", defaultUnit: "pg/mL" },
  { name: "hCG", defaultUnit: "mIU/mL" },
];

export const UNITS: string[] = [
  "mIU/mL",
  "ng/mL",
  "pg/mL",
  "pmol/L",
  "nmol/L",
  "IU/L",
  "mIU/L",
  "mg/dL",
  "g/dL",
  "ng/dL",
  "μg/dL",
  "%",
  "U/L",
];
